export const getCookie = (key: string) => {
	const b = document.cookie.match('(^|;)\\s*' + key + '\\s*=\\s*([^;]+)');
	const value = b ? b.pop() : '';
	return decodeURIComponent(value as string);
};
